/** Green "live" dot with a pulsing halo ring (prototype `.h-live`). */
import { FC, useEffect, useRef } from "react"
import { Animated, Easing, View, ViewStyle } from "react-native"

import { prefersReducedMotion } from "./motion"
import { tokens } from "./tokens"

export const LiveDot: FC = () => {
  const pulse = useRef(new Animated.Value(0)).current

  useEffect(() => {
    if (prefersReducedMotion()) return
    const loop = Animated.loop(
      Animated.timing(pulse, {
        toValue: 1,
        duration: 1800,
        easing: Easing.out(Easing.quad),
        useNativeDriver: false,
      }),
    )
    loop.start()
    return () => loop.stop()
  }, [pulse])

  return (
    <View style={$dot} accessibilityElementsHidden importantForAccessibility="no-hide-descendants">
      <Animated.View
        style={[
          $halo,
          {
            opacity: pulse.interpolate({ inputRange: [0, 1], outputRange: [1, 0] }),
            transform: [
              { scale: pulse.interpolate({ inputRange: [0, 1], outputRange: [0.6, 1.6] }) },
            ],
          },
        ]}
      />
    </View>
  )
}

const $dot: ViewStyle = {
  width: 10,
  height: 10,
  borderRadius: 5,
  backgroundColor: tokens.green,
  marginHorizontal: 4,
}
const $halo: ViewStyle = {
  position: "absolute",
  top: -4,
  left: -4,
  right: -4,
  bottom: -4,
  borderRadius: 9,
  backgroundColor: tokens.greenHalo,
}
